import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { environment } from '../environments/environment'
import { SwUpdate } from '@angular/service-worker'
import { Data, RouterOutlet } from '@angular/router'
import { routeAnimations } from '@unesp/core'
import packageJson from '../../package.json'
import { datadogRum } from '@datadog/browser-rum'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeAnimations],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppComponent implements OnInit {
  version: string = packageJson.version
  env = environment
  fullTitle = `Sistema de Pós-graduação v${this.version}`
  shortTitle = `SISPG v${this.version}`
  footerText = 'PROPG - Pró-reitoria de Pós-graduação'
  logoCustom = 'assets/img/logo.svg'

  constructor(private swUpdate: SwUpdate) {}

  ngOnInit(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(async event => {
        switch (event.type) {
          case 'VERSION_DETECTED':
            console.log(`Downloading new app version: ${event.version.hash}`)
            break
          case 'VERSION_READY':
            console.log(`Current app version: ${event.currentVersion.hash}`)
            console.log(`New app version ready for use: ${event.latestVersion.hash}`)
            await this.swUpdate.activateUpdate()
            alert('O sistema foi atualizado!')
            location.reload()
            break
          case 'VERSION_INSTALLATION_FAILED':
            console.error(`Failed to install app version '${event.version.hash}': ${event.error}`)
            break
        }
      })
    }
    if (this.env.production == false) {
      this.footerText = this.env.name
    }
    if (this.env.production) {
      datadogRum.init({
        applicationId: 'bd8a057c-f15e-447a-b752-e4fd24e76f66',
        clientToken: 'pub89308507fbd880762cc80b006f466575',
        site: 'datadoghq.com',
        service: 'sispg',
        env: this.env.tag,
        version: this.version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: ['https://app.unesp.br', 'https://sistemas.unesp.br'],
      })
    }
  }

  prepareRoute(outlet: RouterOutlet): Data {
    return outlet && outlet.activatedRouteData
  }
}
